import Table from "../../../../components/table";


function RatingStatus(props:any) { 
    return (
    <section className="tableStyle">
        <Table type={'rating'} data={props.data} sendReminder={props.sendReminder}/>
    </section>
  )
}


export default RatingStatus